import { render, staticRenderFns } from "./user-center-wrap.vue?vue&type=template&id=8169e1fa&scoped=true"
import script from "./user-center-wrap.vue?vue&type=script&lang=js"
export * from "./user-center-wrap.vue?vue&type=script&lang=js"
import style0 from "./user-center-wrap.vue?vue&type=style&index=0&id=8169e1fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8169e1fa",
  null
  
)

export default component.exports